module.exports = __webpack_public_path__ + "static/img/focusCode@2x2.d67b847.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/fixed/img/focusCode@2x2.jpg
// module id = e1SO
// module chunks = 22